import PropTypes from 'prop-types';
import clsx from 'clsx';
import NumberFormat from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useRouter } from 'next/router';
import AddButton from '../../../../AddButton';
import currencySymbol from '../../../../../helpers/currencySymbol';
import { addToTrip, removeFromTrip, saveTripRequest } from '../../../../../store/slices/trip';
import { PageLinks } from '../../../../../constants';
import Button from '../../../../Button';
import TourAddUpdateToBrochure from '../../../AddUpdateBrochure/TourAddUpdateToBrochure';

const PricingDetails = ({
  itinerary, tripId,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { tripConfirmation } = useSelector((store) => store.trip);
  const selectedTrip = useSelector((store) => store.trip
    .selectedTrips[tripConfirmation && tripConfirmation.tripId ? tripConfirmation.tripId : tripId]);
  const { pageName } = router.query;
  const { isViewingBrochure } = useSelector((state) => state.brochure);
  const { isViewingCompare } = useSelector((state) => state.compare);
  const doCheckoutOnSelect = pageName === PageLinks.ChangeTour.pageName;
  const { selectedTrips } = useSelector((state) => state.trip);
  const trip = selectedTrips && tripId && selectedTrips[tripId];

  const handleAddToTripClick = (rate) => {
    if (tripId) {
      const tourItinerary = JSON.parse(JSON.stringify({
        ...itinerary,
        selectedRate: rate,
        selectedRateCode: rate.code,
        rates: [{ ...rate }],
      }));
      dispatch(addToTrip({
        tripId,
        trip: {
          tourItinerary,
        },
      }));
    }
  };

  const handleCheckoutOnRateClick = (rate) => {
    if (tripId) {
      const request = {
        tripId,
        ignoreUpdateTripOnSuccess: true,
        trip: {
          tripId,
          tourItinerary: {
            ...itinerary,
            selectedRate: rate,
            selectedRateCode: rate.code,
            tripSegmentId: selectedTrip && selectedTrip.tourItinerary
              && selectedTrip.tourItinerary.tripSegmentId,
          },
          doChangeItineraryInBookedTrip: pageName === PageLinks.ChangeTour.pageName,
          doAddItineraryInBookedTrip: pageName === PageLinks.AddTour.pageName,
        },
      };
      dispatch(saveTripRequest(request));
    }
  };

  const handleRemoveFromTrip = useCallback(() => {
    dispatch(removeFromTrip({ tripId, key: 'tourItinerary' }));
  }, [dispatch, tripId]);

  const checkIsSelected = useCallback((item) => {
    if (trip) {
      return (trip.tourItinerary
        && trip.tourItinerary.selectedRate
        && trip.tourItinerary.selectedRate.code === item.code);
    }
    return false;
  }, [trip]);

  return (itinerary.rates ? (itinerary.rates.map((rate) => (
    <div key={rate.code} className="grid grid-cols-9 w-full mb-4">
      <div className="sm:col-span-7 col-span-6">
        {rate.name}
      </div>
      <div className="sm:col-span-2 col-span-3 text-right mb-1">
        <div className="text-right inline-block whitespace-no-wrap">
          <div className={clsx('font-bold leading-tight text-left md:text-right self-center', { 'text-sm': '' })}>
            Total
            <NumberFormat value={rate.price} displayType="text" thousandSeparator prefix={` ${currencySymbol()}`} fixedDecimalScale decimalScale={2} />
          </div>
          {
                tripId && (
                  <div>
                    {doCheckoutOnSelect ? (
                      <Button
                        onClick={() => handleCheckoutOnRateClick(rate)}
                        size={Button.buttonSizes.SM}
                      >
                        Select
                      </Button>
                    ) : (
                      <AddButton
                        isSelected={checkIsSelected(rate)}
                        onAdd={() => handleAddToTripClick(rate)}
                        onRemove={handleRemoveFromTrip}
                        addLabel="Add to Trip"
                        removeLabel="Remove"
                      />
                    )}
                  </div>
                )
              }
          <div>
            {!isViewingBrochure && !isViewingCompare && <TourAddUpdateToBrochure className="" rate={rate} tripId={tripId} tourItinerary={itinerary} />}
          </div>
        </div>
      </div>
    </div>
  ))) : <></>
  );
};

PricingDetails.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  tripId: PropTypes.string,
};

PricingDetails.defaultProps = {
  tripId: '',
};

export default PricingDetails;
